import React from 'react';
import { RouterProviderApp } from './router';

export default function App() {
  return <RouterProviderApp />;
}